import { render, staticRenderFns } from "./index.vue?vue&type=template&id=063f0b26&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f0b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063f0b26')) {
      api.createRecord('063f0b26', component.options)
    } else {
      api.reload('063f0b26', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=063f0b26&scoped=true", function () {
      api.rerender('063f0b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Weforsys-table-draggable/index.vue"
export default component.exports